import { render, staticRenderFns } from "./newsletterC.vue?vue&type=template&id=158f7022"
import script from "./newsletterC.vue?vue&type=script&lang=js"
export * from "./newsletterC.vue?vue&type=script&lang=js"
import style0 from "./newsletterC.vue?vue&type=style&index=0&id=158f7022&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports